exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel--slidable {\n  touch-action: initial !important;\n}\n.carousel__list li {\n  position: relative;\n  padding-top: 100%;\n}\n.carousel__list li span {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n}\n.carousel__list li span img {\n  height: 100%;\n  width: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n.carousel__control {\n  z-index: 2;\n}", ""]);

// exports
